module.exports = __webpack_public_path__ + "0c3425c7a42c10b60d40ece3617bfa34.MP3";